import { PILL } from "@/lib/constants";

export function Pill({ kind, value, testId, className = "" }) {
  const cls = PILL[kind]?.[value] || "bg-zinc-100 text-zinc-700 border-zinc-300";
  return (
    <span data-testid={testId} className={`pill ${cls} ${className}`}>
      {value}
    </span>
  );
}
